import axiosInstanceNew from "lib/axiosinstanceNew";

const InterestedTutor = class {
    constructor() {
        this.baseUrl = "enquiry/interested_tutor/";
}


async listAllinterestedtutor() {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}`)
    ).data;
  }
  async listAllinterestedtutorbyId(id) {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}?enquiry_id=${id}`)
    ).data;
  }

}
export default new InterestedTutor();
